var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import React, { useCallback, useState } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { useDispatch } from 'react-redux';
import { scroller } from 'react-scroll';
import { addJsonLdFaq } from '../../actions/JsonLdActions';
import { sleep } from '../../helpers/common';
import { propLocation } from '../../helpers/custom-prop-types';
import { useDidMount } from '../../helpers/use/useHook';
import Layout from '../Layout';
import { FAQ_CONTENT1 } from './Contents/Faq1';
import { FAQ_CONTENT2 } from './Contents/Faq2';
import { FAQ_CONTENT3 } from './Contents/Faq3';
import { FAQ_CONTENT4 } from './Contents/Faq4';
import FaqContent from './FaqContent';
const tabs = [
    'サービスについて',
    'クライアント企業',
    'コンサルタント',
    '情報セキュリティについて',
];
const tabContents = [
    { items: FAQ_CONTENT1, tabNo: 1 },
    { items: FAQ_CONTENT2, tabNo: 2 },
    { items: FAQ_CONTENT3, tabNo: 3 },
    { items: FAQ_CONTENT4, tabNo: 4 },
];
const Faq = (props) => {
    const { location } = props;
    const dispatch = useDispatch();
    // タブの表示管理
    const [showTab, setShowTab] = useState(1);
    // 質問の開閉状態管理
    const [showQuestions, setShowQuestions] = useState(() => 
    // 質問の開閉状態管理 初期値（全て閉じた状態）
    _.reduce(tabContents, (result, { items, tabNo }) => {
        const questions = _.flatten(items.map(({ contents }) => contents));
        const displayState = {};
        _.forEach(questions, ({ question }) => {
            displayState[question] = false;
        });
        return Object.assign(Object.assign({}, result), { [tabNo]: displayState });
    }, {}));
    const changeIsShow = (tabNo, question) => {
        setShowQuestions((prev) => (Object.assign(Object.assign({}, prev), { [tabNo]: Object.assign(Object.assign({}, prev[tabNo]), { [question]: !prev[tabNo][question] }) })));
    };
    const moveUpToQuestion = useCallback((tab, question) => __awaiter(void 0, void 0, void 0, function* () {
        const tabNo = typeof tab === 'string' ? parseInt(tab, 10) : tab;
        setShowTab(tabNo);
        changeIsShow(tabNo, question);
        yield sleep(0.1);
        scroller.scrollTo(`${tab}_${question}`, {
            duration: 500,
            offset: -120,
            smooth: true,
        });
    }), [setShowTab]);
    const changeTab = useCallback((e) => {
        e.preventDefault();
        setShowTab(parseInt(e.target.value, 10));
    }, [setShowTab]);
    useDidMount(() => {
        // 対象の質問まで移動
        const hash = (location.hash || '').substr(1);
        const hashParts = hash.split('_') || [];
        const tab = hashParts[0] || 0;
        const question = (() => {
            try {
                return decodeURIComponent(hashParts[1]);
            }
            catch (e) {
                return '';
            }
        })() || '';
        if (tab && question && tab >= 1 && tab <= 4) {
            moveUpToQuestion(tab, question);
        }
        // JSON-LD追加
        const allFaqContents = _.flatten([...FAQ_CONTENT1, ...FAQ_CONTENT2, ...FAQ_CONTENT3, ...FAQ_CONTENT4].map(({ contents }) => contents));
        const mainEntity = allFaqContents.map(({ answer, question: questionText }) => ({
            '@type': 'Question',
            acceptedAnswer: {
                '@type': 'Answer',
                text: renderToStaticMarkup(answer),
            },
            name: questionText,
        }));
        dispatch(addJsonLdFaq(mainEntity));
    });
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main layout_faq' }, { children: [_jsxs("div", Object.assign({ className: 'l-sub-header l-sub-header-faq l-container-12' }, { children: [_jsxs("h1", { children: ["\u3088\u304F\u3042\u308B\u8CEA\u554F", _jsx("span", { children: "FAQ" })] }), _jsx("ul", Object.assign({ className: 'tabs faq l-container-9' }, { children: tabs.map((tab, index) => (_jsx("li", Object.assign({ className: showTab === index + 1 ? 'active' : '' }, { children: _jsx("button", Object.assign({ href: `#tab${index + 1}`, onClick: changeTab, type: 'button', value: index + 1 }, { children: tab })) }), tab))) }))] })), _jsx("div", Object.assign({ className: 'l-tab l-container-9' }, { children: tabContents.map(({ items, tabNo }) => (_jsx(FaqContent, { changeIsShow: changeIsShow, isShow: showTab === tabNo, items: items, onLinkClick: moveUpToQuestion, showQuestions: showQuestions[tabNo], tabNo: tabNo }, tabNo))) }))] })));
};
Faq.propTypes = {
    location: propLocation(),
};
export default Faq;
